import { FIBER_POP_UPDATE_SITE } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const updateFiberPopSite = async (id, payload) => {
  try {
    const response = await apiClient.put(FIBER_POP_UPDATE_SITE(id), payload);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
